// extracted by mini-css-extract-plugin
var _1 = "EmailVariablesReportTableRow-moduleEmailVariablesReportTableRow__N22Tg TableComponent-modulerow__xPAo4";
export { _1 as "EmailVariablesReportTableRow" }
